var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('new-modal-wrapper', {
    ref: "newTermsConditionModal",
    class: "new-terms-condition-modal-step-".concat(_vm.componentName),
    attrs: {
      "modal-name": "newTermsConditionModal",
      "headerTitle": _vm.$store.state.translations.data.twoStepsTermsConditionModalHeaderTitle,
      "widthModal": "100%",
      "heightModal": _vm.fullScreen ? '100%' : 'auto',
      "fullHeight": true,
      "cta-primary-button": _vm.ctaButtons[_vm.componentName],
      "cta-primary-button-icon-name": _vm.ctaButtonIcons[_vm.componentName].name,
      "cta-primary-button-icon-type": _vm.ctaButtonIcons[_vm.componentName].type,
      "max-width-modal": _vm.fullScreen ? Infinity : 500,
      "click-to-close": false,
      "modalClasses": _vm.modalClasses,
      "type": _vm.type,
      "dialogDesc": true
    },
    on: {
      "cta-action": _vm.onCtaAction,
      "go-back": _vm.onGoBack,
      "closed": _vm.onClose,
      "before-open": _vm.beforeOpenModal
    }
  }, [_c('terms-conditions-text', _vm._b({
    ref: "content",
    on: {
      "showBackButton": _vm.showBackButton,
      "showIconButton": _vm.showIconButton
    }
  }, 'terms-conditions-text', _vm.componentAttributes[_vm.componentName], false)), _c('terms-conditions-form', _vm._b({
    ref: "content",
    on: {
      "showBackButton": _vm.showBackButton,
      "showIconButton": _vm.showIconButton,
      "showCtaButton": _vm.showCtaButton,
      "blockCtaPrimaryButton": _vm.blockCtaPrimaryButton
    }
  }, 'terms-conditions-form', _vm.componentAttributes[_vm.componentName], false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }